// @flow

import type { Action } from "redux-action";
import { beginRequest, completeRequest } from "@store/utils";

import type { ApprovableContainer } from "@modules/service/types";
import type { AlertsState, Alert } from "./types";

const startRequest = beginRequest(["requestsInProgress"]);

const finishRequest = completeRequest(["requestsInProgress"]);

// Get  List

export const onDisableAlert = (state: AlertsState) => () => startRequest(state);
export const onDisableAlertSuccess = (state: AlertsState) => () => finishRequest(state);
export const onDisableAlertError = (state: AlertsState) => () => finishRequest(state);

export const onUpdateAlert = (state: AlertsState) => () => startRequest(state);
export const onUpdateAlertSuccess = (state: AlertsState) => () => finishRequest(state);
export const onUpdateAlertError = (state: AlertsState) => () => finishRequest(state);

export const onResetAlertsState = (state: AlertsState) => () => ({
  ...state,
  current: null,
  draft: null,
  assignments: [],
});

export const onGetAlertsList = (state: AlertsState) => () => startRequest(state);

export const onGetAlertsListSuccess = (state: AlertsState) => ({ payload }: Object) => {
  return {
    ...state,
    error: null,
    list: payload,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
  };
};

export const onAddAlert = (state: AlertsState) => ({ payload }: Object) => {
  return { ...state, ...startRequest(state) };
};
export const onAddAlertSuccess = (state: AlertsState) => ({ payload }: Object) => {
  let list = state.list || [];
  list.push(payload);
  return {
    ...state,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    list,
  };
};

export const onGetAlertsListError = (state: AlertsState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

// Get  Record

export const onGetAlert = (state: AlertsState) => () => startRequest(state);

export const onGetAlertSuccess = (state: AlertsState) => ({ payload }: Object) => {
  return {
    ...state,
    error: null,
    current: payload,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
  };
};

export const onGetAlertError = (state: AlertsState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

// Get  Schema

export const onGetSchema = (state: AlertsState) => () => startRequest(state);

export const onGetSchemaSuccess = (state: AlertsState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  schema: payload,
});

export const onGetSchemaError = (state: AlertsState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

// Create

export const onNew = (state: AlertsState) => (action: Action<void>) => ({
  ...state,
  draft: {
    content: {
      details: {},
    },
  },
});

export const onStartDraftSuccess = (state: AlertsState) => (
  action: Action<ApprovableContainer<Alert>>,
) => ({
  ...state,
  draft: (action.payload && action.payload.active) || {},
});

export const onSetDraft = (state: AlertsState) => ({ payload }: Object) => ({
  ...state,
  draft: payload,
});

export const onNewAssignments = (state: AlertsState) => (action: Action<void>) => ({
  ...state,
  assignments: [],
});

export const onSetAssignments = (state: AlertsState) => ({ payload }: Object) => ({
  ...state,
  assignments: payload,
});

export const onSetAlertDraftAssignments = (state: AlertsState) => ({ payload }: Object) => ({
  ...state,
  draftAssignments: payload,
});

// Modals

export const onSetShowAddAlertRecipientModal = (state: AlertsState) => ({ payload }: any) => {
  state.modals.showAddAlertRecipientModal = payload;
  return state;
};

export const onSetShowAddAlertAttachmentModal = (state: AlertsState) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showAddAlertAttachmentModal: payload,
  },
});

export const onSetShowDeleteAlertAttachmentModal = (state: AlertsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showDeleteAlertAttachmentModal: payload,
  },
});
